import * as React from 'react';
export const mcpServerSvg = React.forwardRef(function mcpServerSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.898.868a2.953 2.953 0 0 1 5.02 2.41A2.953 2.953 0 0 1 14.33 8.3l-5.366 5.368a.35.35 0 0 0 0 .495l.709.71a.65.65 0 0 1-.919.92l-.71-.71a1.65 1.65 0 0 1 0-2.334l5.367-5.367a1.653 1.653 0 1 0-2.338-2.337l-4.44 4.44a.649.649 0 1 1-.918-.92l4.44-4.44a1.653 1.653 0 0 0-2.337-2.336L1.91 7.695a.65.65 0 0 1-.92-.92L6.898.868Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.522 2.502a.65.65 0 0 1 .92.92l-4.44 4.44a1.653 1.653 0 0 0 2.336 2.337l4.44-4.44a.651.651 0 0 1 .92.92l-4.441 4.439A2.953 2.953 0 1 1 4.08 6.942l4.44-4.44Z',
    }),
  );
});
mcpServerSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mcpServer = {
  category: 'icon',
  colorable: true,
  name: 'mcpServer',
  svg: mcpServerSvg,
};
